import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminInterest = lazy(() => import("@/pages/admin/AdminInterest"));

export const Route = createFileRoute("/admin/intresse")({
  component: () => <AdminInterest />,
});
